/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
// import { Badge } from "antd";
import {
  Collapse,
  Form,
  Flex,
  Row,
  Col,
  Space,
  Card,
  message,
  Input,
  DatePicker,
  Tabs
} from "antd";
import { Button, Table, Typography } from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import { accessColumn, materialColumn } from "./model";
import useAccessPageState from '../../../../hooks/useAccessPageState';
import "./MyPage.css";
import dayjs from "dayjs";
// import OptionService from "../../../service/ERP/Options.service";
// import dayjs from 'dayjs';
import ReportService from "../../../../service/ERP/Report.service";
import { formatMoney } from "../../../../utils/util";
import { TbFileExport } from "react-icons/tb";
import CalculateByProduct from "./ByProduct";
import useOpenDoc from "../../../../hooks/useOpenDoc";
// const opService = OptionService();
const reportservice = ReportService();
const RangePicker = DatePicker.RangePicker;

const CalculateMaterialAccess = () => {
  const [form] = Form.useForm();
  const [accessData, setAccessData] = useState([]);
  const [rawData, setRawData] = useState([]);

  //cut fg and wi
  const [resultData, setResultData] = useState([]);
  const [resultDataPK, setResultDataPK] = useState([]);

  //all data
  const [allResultData, setAllResultData] = useState([]);
  const [allResultDataPK, setAllResultDataPK] = useState([]);
  const [allRawRows, setAllRawRows] = useState([]);
  const [allPkRows, setAllPkRows] = useState([]);

  const [activeSearch, setActiveSearch] = useState([]);
  const {
    tablePagination,
    saveState,
    restoreState,
    clearState,
    restoreDefaultPagination,
    handleTableChange,
  } = useAccessPageState({ form });
  const [checkStrictly] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isCombinedView, setIsCombinedView] = useState(true);
  const [isCalculated, setIsCalculated] = useState(false);

  // const { Text } = Typography;

  const handleSearch = (load = false, forcedValues = null, paginationOverride = null) => {
    const runSearch = (v) => {
      saveState(v, paginationOverride ?? tablePagination);
      setIsCalculated(false);
      setIsCombinedView(true);
      setResultData([]);
      setResultDataPK([]);
      setAllResultData([]);
      setAllResultDataPK([]);

      const data = { ...v };
      if (!!data?.jodate) {
        const arr = data?.jodate.map((m) => dayjs(m).format("YYYY-MM-DD"));
        const [jodate_form, jodate_to] = arr;

        //data.dndate = arr
        Object.assign(data, { jodate_form, jodate_to });
      }
      reportservice
        .prepareCalculateMaterial(data, {
          ignoreLoading: load || Object.keys(data).length !== 0,
        })
        .then((res) => {
          const { data } = res.data;

          // สร้าง tree structure
          const map = new Map();
          let seqCounter = 1;
          data.forEach((row) => {
            if (!map.has(row.jocode)) {
              map.set(row.jocode, {
                // jocode: row.jocode,
                seq: seqCounter++,
                jocode: row.jocode.toString(),
                cusname: row.cusname,
                children: [],
              });
            }
            if (row.detail_id) {
              map.get(row.jocode).children.push({
                seq: seqCounter++,
                jocode: row.jocode.toString(),
                cusname: row.cusname,
                pg_code: row.pg_code,
                pg_name: row.pg_name,
                fg_code: row.fg_code,
                fg_name: row.fg_name,
                bom: row.bom,
                code: row.product_code,
                carton: row.carton,
                unit_cs: row.unit_cs,
                detail_code: row.detail_code,
              });
            }
          });

          let mapdata = Array.from(map.values());

          // console.log(mapdata)

          setAccessData(mapdata);
        })
        .catch((err) => {
          console.log(err);
          message.error("Request error!");
        });
    };

    if (useAccessPageState.canUseForcedSearchValues(forcedValues)) {
      runSearch(forcedValues);
      return;
    }

    form.validateFields().then((v) => {
      runSearch(v);
    });
  };

  const handleCal = async () => {
    // clearState(); // เคลียร์ข้อมูลก่อนเริ่มคำนวณ

    const combinedData = rawData.reduce((acc, row) => {
      if (!row.children) {
        acc.push(row); // ถ้าไม่มี children ก็เพิ่ม row เข้าไปใน acc
      }
      return acc;
    }, []);
    // console.log("Combined Data:", combinedData);

    // เพิ่มการคำนวณและจัดรูปแบบใน combinedData
    const formattedData = combinedData.map((v) => ({
      ...v,
      qty: formatMoney(Number(v.carton) * Number(v.unit_cs)), // เพิ่มฟิลด์ totalValue
    }));

    // console.log("Formatted Data:", formattedData);

    reportservice
      .getCalculateMaterial(formattedData)
      .then((res) => {
        const { rawmat, pkmat, pkRows,rawRows } = res.data;
        // console.log("Result Data:", res.data);
        setResultData(rawmat.filter((item) => item.typename !== "Finish Goods"&& item.typename !== "Work Instruction"&& item?.typename !== "Packing" && item?.typename !== "Packaging" && item?.typename !== "")); // อัปเดต resultData
        setResultDataPK(pkmat); // อัปเดต resultDataPK
        setAllRawRows(rawRows || []);
        setAllPkRows(pkRows || []);

        const filteredRawRows = (rawRows || []).filter(
          (item) => item?.typename === "Ingredients" || item?.typename === "Raw Material" || item?.typename === "Work Instruction"
        );
        const filteredPkRows = (pkRows || []).filter(
          (item) => item?.typename === "Packing" || item?.typename === "Packaging"
        );

        setAllResultData(filteredRawRows);
        setAllResultDataPK(filteredPkRows);

        setIsCalculated(true);
        
      })
      .catch((err) => {
        console.log(err);
        message.error("Request error!");
        setIsCalculated(false);
      });
  };

  const handleClearSearch = () => {
    clearState();
    form.resetFields();

    const nextPagination = restoreDefaultPagination();

    handleSearch(false, {}, nextPagination);
  };

  const handleClear = () => {
    clearState();
    setSelectedRowKeys([]); // ยกเลิกการเลือกทั้งหมด
    setRawData([]);
    setIsCalculated(false);
    setIsCombinedView(true);
    setResultData([]);
    setResultDataPK([]);
    setAllResultData([]);
    setAllResultDataPK([]);
    setAllRawRows([]);
    setAllPkRows([]);
    form.resetFields();
    restoreDefaultPagination();
  };

  useEffect(() => {
    const initeil = () => {
      const restored = restoreState();

      handleSearch(false, restored?.searchValues ?? null, restored?.tablePagination);
    };

    initeil();
  }, []);

  useEffect(() => {
    if (!isCalculated && !isCombinedView) {
      setIsCombinedView(true);
    }
  }, [isCalculated, isCombinedView]);

  const handleExportReportStockCard = React.useCallback(async () => {
    try {
      if (resultData.length === 0) {
        message.warning("ไม่มีข้อมูลสำหรับ Export");
        return;
      }

      await reportservice.getCalculateMaterialDownload({ data: resultData });
    } catch (error) {
      console.error("Error fetching report data:", error);
      return [];
    } finally {
      // setLoading(false);
    }
  }, [resultData]);


  const handleExportGroupExcel = React.useCallback(async (rows) => {
    try {
      if (!rows || rows.length === 0) {
        message.warning("ไม่มีข้อมูลสำหรับ Export");
        return;
      }

      await reportservice.getCalculateMaterialDownload({ data: rows });
    } catch (error) {
      console.error("Error fetching report data:", error);
      return [];
    }
  }, []);

  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys, record) => {
      setRawData(record);
      setSelectedRowKeys(newSelectedRowKeys);
    },
    onSelect: (record, selected, selectedRows) => {
      // console.log(record, selected, selectedRows);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      // console.log(selected, selectedRows, changeRows);
    },
  };

  const { openJo } = useOpenDoc();
  const column = accessColumn({ openJo });
  const matcolumn = materialColumn({});

  const compareParentItemCode = React.useCallback((a, b) => {
    const normalize = (v) => String(v ?? "").trim().toUpperCase();

    const rank = (v) => {
      const s = normalize(v);
      if (!s) return 100;
      if (s === "ไม่ระบุ") return 101;
      if (s.startsWith("PG")) return 0;
      if (s.startsWith("FG")) return 1;
      if (s.startsWith("WI")) return 2;
      return 99;
    };

    const ak = normalize(a);
    const bk = normalize(b);
    const ar = rank(ak);
    const br = rank(bk);

    if (ar !== br) return ar - br;
    return ak.localeCompare(bk);
  }, []);

  const groupedAllResultData = React.useMemo(() => {
    const groups = new Map();
    (allResultData || []).forEach((row) => {
      const key = row?.parent_item_code || "ไม่ระบุ";
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(row);
    });
    return Array.from(groups.entries()).sort(([a], [b]) =>
      compareParentItemCode(a, b)
    );
  }, [allResultData, compareParentItemCode]);

  const groupedAllResultDataPK = React.useMemo(() => {
    const groups = new Map();
    (allResultDataPK || []).forEach((row) => {
      const key = row?.parent_item_code || "ไม่ระบุ";
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(row);
    });
    return Array.from(groups.entries()).sort(([a], [b]) =>
      compareParentItemCode(a, b)
    );
  }, [allResultDataPK, compareParentItemCode]);

  const parentNameByCode = React.useMemo(() => {
    const lookup = new Map();

    (rawData || []).forEach((row) => {
      if (row?.children) return;

      const parentCode = row?.fg_code || row?.code;
      const parentName = row?.fg_name || row?.pg_name;

      if (parentCode && parentName && !lookup.has(parentCode)) {
        lookup.set(parentCode, parentName);
      }
    });

    [...(allRawRows || []), ...(allPkRows || [])].forEach((row) => {
      const itemCode = row?.mat_code;
      const itemName = row?.mat_name;

      if (itemCode && itemName && !lookup.has(itemCode)) {
        lookup.set(itemCode, itemName);
      }
    });

    return lookup;
  }, [rawData, allRawRows, allPkRows]);

  const CollapseItemSearch = (
    <>
      <Row gutter={[8, 8]}>
        <Col xs={24} sm={8} md={8} lg={8} xl={8}>
          <Form.Item label="JO Code" name="jocode" onChange={handleSearch}>
            <Input placeholder="Enter Jo Code" />
          </Form.Item>
        </Col>

        <Col xs={24} sm={8} md={8} lg={8} xl={8}>
          <Form.Item label="Job Order Date." name="jodate">
            <RangePicker
              placeholder={["From Date", "To date"]}
              style={{ width: "100%", height: 40 }}
              onChange={handleSearch}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8} md={8} lg={8} xl={8}>
          <Form.Item label="Customer Name" name="cusname">
            <Input placeholder="Enter Customer Name." />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[8, 8]}>
        <Col xs={24} sm={8} md={12} lg={12} xl={12}>
          {/* Ignore */}
        </Col>
        <Col xs={24} sm={8} md={12} lg={12} xl={12}>
          <Flex justify="flex-end" gap={8}>
            <Button
              type="primary"
              size="small"
              className="bn-action"
              icon={<SearchOutlined />}
              onClick={() => handleSearch()}
            >
              Search
            </Button>
            <Button
              type="primary"
              size="small"
              className="bn-action"
              danger
              icon={<ClearOutlined />}
              onClick={() => handleClearSearch()}
            >
              Clear
            </Button>
          </Flex>
        </Col>
      </Row>
    </>
  );

  const FormSearch = (
    <Collapse
      size="small"
      onChange={(e) => {
        setActiveSearch(e);
      }}
      activeKey={activeSearch}
      items={[
        {
          key: "1",
          label: (
            <>
              <SearchOutlined />
              <span> Search</span>
            </>
          ),
          children: <>{CollapseItemSearch}</>,
          showArrow: false,
        },
      ]}
      // bordered={false}
    />
  );

  const TitleTable = (
    <Flex className="width-100" align="center">
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start" align="center">
          <Typography.Title className="m-0 !text-zinc-800" level={3}>
            ตารางคำนวนวัถตุดิบ
          </Typography.Title>
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          <Button
            size="small"
            icon={<TbFileExport style={{ fontSize: ".9rem" }} />}
            className="bn-action bn-center bn-success-outline justify-center"
            onClick={() => handleExportReportStockCard()}
          >
            <Typography.Text style={{ color: "var(--success)" }}>
              Export to Excel
            </Typography.Text>
          </Button>
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}></Col>
    </Flex>
  );

  const TitleTablePK = (label, rows) => (
    <Flex className="width-100" align="center">
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start" align="center">
          <Typography.Title className="m-0 !text-zinc-800" level={3}>
            {label}
          </Typography.Title>
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          <Button
            size="small"
            icon={<TbFileExport style={{ fontSize: ".9rem" }} />}
            className="bn-action bn-center bn-success-outline justify-center"
            onClick={() => handleExportGroupExcel(rows)}
          >
            <Typography.Text style={{ color: "var(--success)" }}>
              Export to Excel
            </Typography.Text>
          </Button>
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}></Col>
    </Flex>
  );
  const JoTabContent = (
      <Space
        direction="vertical"
        size="middle"
        style={{ display: "flex", position: "relative" }}
      >
        <Form
          form={form}
          layout="vertical"
          autoComplete="off"
          onValuesChange={() => {
            handleSearch(true);
          }}
        >
          {FormSearch}
        </Form>
        <Card>
          <Row gutter={[8, 8]}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Table
                size="small"
                rowKey="seq"
                columns={column}
                dataSource={accessData}
                rowSelection={Object.assign(Object.assign({}, rowSelection), {
                  checkStrictly,
                })}
                scroll={{ x: "max-content" }}
                pagination={tablePagination}
                onChange={handleTableChange}
              />
            </Col>
          </Row>
          <Row gutter={[8, 8]}>
            <Col xs={24} sm={8} md={12} lg={12} xl={12}>
              {/* Ignore */}
            </Col>
            <Col xs={24} sm={8} md={12} lg={12} xl={12}>
              <Flex justify="flex-end" gap={8}>
                <Button
                  type="primary"
                  size="small"
                  className="bn-action"
                  icon={<SearchOutlined />}
                  onClick={() => handleCal()}
                >
                  ค้นหา
                </Button>
                <Button
                  type="primary"
                  size="small"
                  className="bn-action"
                  danger
                  icon={<ClearOutlined />}
                  onClick={() => handleClear()}
                >
                  ล้าง
                </Button>
              </Flex>
            </Col>
          </Row>
        </Card>

        <Tabs
          activeKey={isCombinedView ? "combined" : "separate"}
          onChange={(key) => setIsCombinedView(key === "combined")}
          items={[
            {
              key: "combined",
              label: "คำนวนแบบรวม",
              children: (
                <>
                  <Card>
                    <br></br>
                    <Row gutter={[8, 8]} className="m-0">
                      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Table
                          title={() => TitleTable}
                          dataSource={resultData}
                          columns={matcolumn}
                          pagination={false}
                          rowKey="seq"
                          scroll={{ x: "max-content" }}
                          size="small"
                          style={{ backgroundColor: "#fafafa" }}
                        />
                      </Col>
                    </Row>
                  </Card>
                  <Card>
                    <br></br>
                    <Row gutter={[8, 8]} className="m-0">
                      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Table
                          title={() => TitleTablePK("ตารางคำนวนบรรจุภัณฑ์ (Packing)", resultDataPK.filter((i) => i.typename === "Packing"))}
                          dataSource={resultDataPK.filter((i) => i.typename === "Packing")}
                          columns={matcolumn}
                          pagination={false}
                          rowKey="seq"
                          scroll={{ x: "max-content" }}
                          size="small"
                          style={{ backgroundColor: "#fafafa" }}
                        />
                      </Col>
                    </Row>
                  </Card>
                  <Card>
                    <br></br>
                    <Row gutter={[8, 8]} className="m-0">
                      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Table
                          title={() => TitleTablePK("ตารางคำนวนภาชนะ (Packaging)", resultDataPK.filter((i) => i.typename === "Packaging"))}
                          dataSource={resultDataPK.filter((i) => i.typename === "Packaging")}
                          columns={matcolumn}
                          pagination={false}
                          rowKey="seq"
                          scroll={{ x: "max-content" }}
                          size="small"
                          style={{ backgroundColor: "#fafafa" }}
                        />
                      </Col>
                    </Row>
                  </Card>
                </>
              ),
            },
            {
              key: "separate",
              label: "คำนวนแบบแยก",
              disabled: !isCalculated,
              children: (
                <>
                  {groupedAllResultData.map(([parentCode, rows]) => {
                    const parentName = parentNameByCode.get(parentCode);

                    return (
                    <Card key={`raw-${parentCode}`}>
                      <br></br>
                      <Row gutter={[8, 8]} className="m-0">
                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                          <Table
                            title={() => (
                              <Flex className="width-100" align="center">
                                <Col span={12} className="p-0">
                                  <Typography.Title
                                    className="m-0 !text-zinc-800"
                                    level={3}
                                  >
                                    Parent Item: {parentCode}
                                    {parentName ? ` ${parentName}` : ""}
                                  </Typography.Title>
                                </Col>
                                <Col span={12} style={{ paddingInline: 0 }}>
                                  <Flex gap={4} justify="end">
                                    <Button
                                      size="small"
                                      icon={(
                                        <TbFileExport
                                          style={{ fontSize: ".9rem" }}
                                        />
                                      )}
                                      className="bn-action bn-center bn-success-outline justify-center"
                                      onClick={() => handleExportGroupExcel(rows)}
                                    >
                                      <Typography.Text
                                        style={{ color: "var(--success)" }}
                                      >
                                        Export to Excel
                                      </Typography.Text>
                                    </Button>
                                  </Flex>
                                </Col>
                              </Flex>
                            )}
                            dataSource={rows}
                            columns={matcolumn}
                            pagination={false}
                            rowKey={(record, index) =>
                              record?.seq ??
                              `${parentCode}-${
                                record?.mat_code ||
                                record?.item_code ||
                                record?.code ||
                                index
                              }`
                            }
                            scroll={{ x: "max-content" }}
                            size="small"
                            style={{ backgroundColor: "#fafafa" }}
                          />
                        </Col>
                      </Row>
                    </Card>
                    );
                  })}

                  {/* {groupedAllResultDataPK.map(([parentCode, rows]) => (
                    <Card key={`pk-${parentCode}`}>
                      <br></br>
                      <Row gutter={[8, 8]} className="m-0">
                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                          <Table
                            title={() => (
                              <Flex className="width-100" align="center">
                                <Col span={12} className="p-0">
                                  <Typography.Title
                                    className="m-0 !text-zinc-800"
                                    level={3}
                                  >
                                    Parent Item: {parentCode}
                                  </Typography.Title>
                                </Col>
                                <Col span={12} style={{ paddingInline: 0 }}>
                                  <Flex gap={4} justify="end">
                                    <Button
                                      size="small"
                                      icon={(
                                        <TbFileExport
                                          style={{ fontSize: ".9rem" }}
                                        />
                                      )}
                                      className="bn-action bn-center bn-success-outline justify-center"
                                      onClick={() => handleExportGroupExcel(rows)}
                                    >
                                      <Typography.Text
                                        style={{ color: "var(--success)" }}
                                      >
                                        Export to Excel
                                      </Typography.Text>
                                    </Button>
                                  </Flex>
                                </Col>
                              </Flex>
                            )}
                            dataSource={rows}
                            columns={matcolumn}
                            pagination={false}
                            rowKey={(record, index) =>
                              record?.seq ??
                              `${parentCode}-${
                                record?.mat_code ||
                                record?.item_code ||
                                record?.code ||
                                index
                              }`
                            }
                            scroll={{ x: "max-content" }}
                            size="small"
                            style={{ backgroundColor: "#fafafa" }}
                          />
                        </Col>
                      </Row>
                    </Card>
                  ))} */}
                </>
              ),
            },
          ]}
        />
      </Space>
  );

  return (
    <div className="calculatebom-report">
      <Tabs
        defaultActiveKey="jo"
        type="card"
        items={[
          {
            key: "jo",
            label: "คำนวนจาก JO",
            children: JoTabContent,
          },
          {
            key: "product",
            label: "คำนวนจากสินค้า",
            children: <CalculateByProduct />,
          },
        ]}
      />
    </div>
  );
};

export default CalculateMaterialAccess;
